/* Native Shopify forms remain the single cart writer. No third-party requests. */
(() => {
  const dispatchKey = date => {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', weekday: 'short', hour: '2-digit', hourCycle: 'h23' }).formatToParts(date).map(p => [p.type, p.value]));
    return ['Sat', 'Sun'].includes(parts.weekday) || (parts.weekday === 'Fri' && Number(parts.hour) >= 12) ? 'monday' : Number(parts.hour) < 12 ? 'today' : 'tomorrow';
  };
  if (!customElements.get('ux-dispatch')) customElements.define('ux-dispatch', class extends HTMLElement {
    connectedCallback() {
      this.update = () => {
        this.querySelector('[data-dispatch-time]').textContent = this.dataset[dispatchKey(new Date())];
        document.querySelectorAll('[data-dispatch-mirror]').forEach(el => { el.textContent = this.textContent.replace(/\s+/g, ' ').trim(); });
      };
      this.update(); this.timer = setInterval(this.update, 60000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
  if (!customElements.get('ux-recommendations')) customElements.define('ux-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.drawer = this.closest('cart-drawer');
      this.loadBound = () => this.load();
      if (this.drawer) {
        this.drawer.addEventListener('ux:drawer-open', this.loadBound);
        if (this.drawer.classList.contains('active')) this.load();
      } else {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
          const cart = event.cartData;
          if (!cart) return;
          const ids = new Set(JSON.parse(this.dataset.cartIds || '[]').map(String));
          if (Array.isArray(cart.items) && 'item_count' in cart) {
            ids.clear(); cart.items.forEach(item => ids.add(String(item.product_id)));
          } else if (cart.product_id) ids.add(String(cart.product_id));
          this.dataset.cartIds = JSON.stringify([...ids]);
          if (this.loaded) { this.loaded = false; this.load(); }
        });
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(e => e.isIntersecting)) { this.observer.disconnect(); this.load(); }
        }, { rootMargin: '150px' });
        this.observer.observe(this.parentElement);
      }
    }
    disconnectedCallback() {
      this.drawer?.removeEventListener('ux:drawer-open', this.loadBound);
      this.unsubscribe?.();
      this.observer?.disconnect(); this.controller?.abort(); clearTimeout(this.timeout);
    }
    async load() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      const excluded = new Set(JSON.parse(this.dataset.cartIds || '[]').map(String));
      const productId = this.drawer?.lastAddedProductId || this.dataset.productId;
      excluded.add(String(productId));
      const fallback = this.querySelector('[data-ux-fallback]').content;
      const output = this.querySelector('[data-ux-results]');
      const select = root => Array.from(root.querySelectorAll('[data-recommendation-card]')).filter(el => !excluded.has(el.dataset.productId));
      let cards = [];
      try {
        if (productId) {
          this.controller = new AbortController();
          const url = new URL(this.dataset.url, location.origin);
          Object.entries({ intent: 'complementary', product_id: productId, limit: '3', section_id: 'ux-complementary' }).forEach(([k,v]) => url.searchParams.set(k,v));
          this.timeout = setTimeout(() => this.controller.abort(), 6000);
          const res = await fetch(url, { signal: this.controller.signal });
          if (!res.ok) throw new Error('Recommendations unavailable');
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          cards = select(doc);
        }
      } catch (_) { /* A missing or slow response uses the rendered fallback. */ }
      clearTimeout(this.timeout);
      if (!this.isConnected) return;
      JSON.parse(this.dataset.cartIds || '[]').forEach(id => excluded.add(String(id)));
      cards = cards.filter(card => !excluded.has(card.dataset.productId));
      const dermoTemplate = this.dataset.context === 'cart_drawer' ? this.querySelector('[data-ux-dermocosmetics]') : null;
      const dermoCards = dermoTemplate ? select(dermoTemplate.content).slice(0,2) : [];
      const dermoIds = new Set(dermoCards.map(card => card.dataset.productId));
      cards = [...dermoCards, ...cards.filter(card => !dermoIds.has(card.dataset.productId))];
      // Fill short API responses too, while keeping exact cart and availability exclusions.
      const ids = new Set(cards.map(c => c.dataset.productId));
      for (const card of select(fallback)) if (!ids.has(card.dataset.productId)) { cards.push(card); ids.add(card.dataset.productId); }
      cards = cards.slice(0,3);
      const fragment = document.createDocumentFragment();
      cards.forEach(card => {
        const copy = card.cloneNode(true);
        copy.querySelectorAll('product-form').forEach(form => { form.dataset.uxSource = this.dataset.context; });
        // Response markup is shared; keep form IDs unique across the drawer and PDP.
        copy.querySelectorAll('form[id]').forEach(form => { form.id = 'p1-rec-' + this.dataset.context + '-' + card.dataset.productId; });
        fragment.append(copy);
      });
      if (!this.isConnected) return;
      output.replaceChildren(fragment);
      this.hidden = cards.length === 0;
      this.loading = false; this.loaded = true;
    }
  });
})();

